import { createContext, useContext } from 'react'

/**
 * The spot in the phone top bar where a page can put its main action (the "+"
 * for Add member, New plan…). Null on wider screens, where the action stays in
 * the page header instead.
 */
export const TopBarSlotContext = createContext<HTMLElement | null>(null)

export function useTopBarSlot(): HTMLElement | null {
  return useContext(TopBarSlotContext)
}
